<template>
	<div>
		<div class="container d-flex align-items-center justify-content-center">
			<div class="col-md-8 col-lg-6 col-xl-5 mb-2">
				<div
					class="card"
					footer-bg-variant="white"
					header-bg-variant="white"
					no-body
				>
					<div class="bg-white card-header">
						<h4 class="card-title mb-0">
							<span>{{ title }}</span>
							<router-link to="/" class="float-right text-muted">SensX Server</router-link>
						</h4>
					</div>
					<b-overlay
						:show="sharedState.loading"
						rounded="sm"
					>
						<div class="list-group list-group-flush">
							<div
								class="list-group-item"
								v-if="sharedState.authError"
							>
								<div
									class="alert alert-danger my-0"
									role="alert"
								>{{ sharedState.authError }}</div>
							</div>
							<div
								class="list-group-item"
								v-if="sharedState.authSuccess"
							>
								<div
									class="alert alert-success my-0"
									role="alert"
								>{{ sharedState.authSuccess }}</div>
							</div>
							<slot />
						</div>
					</b-overlay>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['title'],
}
</script>
